import React from "react"
import WithPages from "./WithPages"

const WithPage = props => {
    return (
        <WithPages>
            {({ pages, onChange, createPage }) => {
                const matches = pages.filter(page => page._sid === props.pageId)
                if (!matches.length) return props.loading ? this.props.loading : ""
                const page = matches[0]

                return props.children({
                    page,
                    onChange: dict => onChange(page._sid, dict),
                    createPage,
                })
            }}
        </WithPages>
    )
}

export default WithPage



// WEBPACK FOOTER //
// ./src/data/wrappers/WithPage.js